import classNames from "classnames";
import AppContext from "PFApp/app_context";
import { BookingModalContextProvider } from "PFApp/booking/components/booking_modal";
import ProfilePreviewSkills from "PFApp/components/profile_preview/parts/profile_preview_skills";
import { LoadingDots } from "PFComponents/loading_dots";
import { isAdmin } from "PFCore/helpers/profile";
import useFocusableElements from "PFCore/helpers/use_focusable_elements.jsx";
import { fetchProfile, fetchProfileAsAdmin } from "PFCore/services/profile";
import { PROFILE_PREVIEW_ACTIONS } from "PFReducers/profile_preview_reducer";
import React, { useContext, useEffect, useRef, useState } from "react";

import ProfilePreviewActionButtons from "./parts/profile_preview_action_buttons";
import ProfilePreviewAvailability from "./parts/profile_preview_availability.jsx";
import ProfilePreviewBasicInfo from "./parts/profile_preview_basic_info";
import ProfilePreviewContact from "./parts/profile_preview_contact.jsx";
import ProfilePreviewCustomFields from "./parts/profile_preview_custom_fields.jsx";
import ProfilePreviewSummary from "./parts/profile_preview_summary.jsx";
import css from "./profile_preview.less";

const ProfilePreview = () => {
  const {
    dispatch,
    currentProfile,
    store: {
      profilePreview: { id, ready, show }
    }
  } = useContext(AppContext);

  const profilePreviewRef = useRef();
  const getFocusablElements = useFocusableElements(profilePreviewRef.current);

  const admin = isAdmin(currentProfile);

  useEffect(() => {
    if (id && show && !ready) {
      const type = PROFILE_PREVIEW_ACTIONS.PROFILE_PREVIEW_DONE;
      fetchProfile(id).then((profile) => dispatch({ type, payload: { profile } }));

      const focusableElements = getFocusablElements();
      focusableElements[0] && focusableElements[0].focus();
    }
  }, [id, show, ready]);

  const [enter, setEnter] = useState(false);
  const [masterExpand, setMasterExpand] = useState(false);

  useEffect(() => {
    setEnter(show);
  }, [show]); // "enter" lags one frame behing "show" so we can have transitions

  return (
    <BookingModalContextProvider fetchProfile={admin ? fetchProfileAsAdmin : undefined} profileId={id}>
      <div
        className={classNames(css.root, { [css.enter]: enter })}
        data-qa-id="ProfilePreview"
        ref={profilePreviewRef}
      >
        <div className={css.top}>
          <ProfilePreviewBasicInfo />
          <ProfilePreviewActionButtons />
        </div>
        <div className={css.inner}>
          <div className={css.innerScroll}>
            <ProfilePreviewContact />
            <ProfilePreviewAvailability />
            <ProfilePreviewSkills masterExpand={masterExpand} setMasterExpand={setMasterExpand} />
            <ProfilePreviewCustomFields only={["grade", "location", "brands", "sectors"]} />
            <ProfilePreviewSummary />

            {!ready && <LoadingDots className={css.loading} />}
          </div>
        </div>
      </div>
    </BookingModalContextProvider>
  );
};

export default ProfilePreview;
